import client from './client';

export const adaptiveMacrosApi = {
  getConfig: (clientId) =>
    client.get('/adaptive-macros/config', { params: { client_id: clientId } }),
  enable: (body) => client.post('/adaptive-macros/enable', body),
  disable: (clientId) =>
    client.post('/adaptive-macros/disable', { client_id: clientId }),
  listAdjustments: (clientId, limit = 50) =>
    client.get('/adaptive-macros/adjustments', {
      params: { client_id: clientId, limit },
    }),
  recompute: (body) => client.post('/adaptive-macros/recompute', body),
};
